//Import 'global' level modules
import 'shared/polyfills';
import 'shared/focusRing';
import 'shared/validation';
import './app';